import faceMassage from '../../assets/images/faceMassage.png'
import photoCertificate from '../../assets/images/photoCertificate.png'
import womanInBathrobe from '../../assets/images/womanInBathrobe.png'

function aboutUs() {
  return (
    <div className='about' id='about'>
      <h2 className='about__title'>О НАС</h2>
      <p className='about__text'>Наша студия подводного массажа — это место, где здоровье и релаксация встречаются в идеальной гармонии. Мы — команда профессионалов, увлечённых идеей оздоровления и восстановления жизненных сил с помощью целебной силы воды.</p>
      <div className='about__images'>
        <img className='about__images-item' src={womanInBathrobe} alt="Женщина в халате" />
        <img className='about__images-item' src={photoCertificate} alt="Сертификат" />
        <img className='about__images-item' src={faceMassage} alt="Массаж лица" />
      </div>
    </div>
   );
}

export default aboutUs;